import styled from "styled-components";
import type { GlobalToken } from "antd";
import { radius } from "@libertify/ui";

export const Subtitle = styled.p<{ $token: GlobalToken }>`
  margin: 0 0 16px;
  color: ${({ $token }) => $token.colorTextSecondary};
  font-size: ${({ $token }) => $token.fontSize}px;
  line-height: 1.5;
`;

export const GroupBlock = styled.div`
  & + & {
    margin-top: 20px;
  }
`;

export const GroupTitle = styled.h3<{ $token: GlobalToken }>`
  margin: 0 0 10px;
  color: ${({ $token }) => $token.colorText};
  font-size: 15px;
  font-weight: ${({ $token }) => $token.fontWeightStrong};
`;

export const AddonCard = styled.button<{ $token: GlobalToken; $selected: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: ${({ $token }) => $token.padding}px;
  text-align: left;
  cursor: pointer;
  font-family: ${({ $token }) => $token.fontFamily};
  background: ${({ $token, $selected }) =>
    $selected ? $token.colorPrimaryBg : $token.colorBgContainer};
  border: ${({ $token, $selected }) =>
    `${$token.lineWidth}px solid ${
      $selected ? $token.colorPrimary : $token.colorBorderSecondary
    }`};
  border-radius: ${radius.box}px;
  transition: border-color ${({ $token }) => $token.motionDurationMid} ease,
    background ${({ $token }) => $token.motionDurationMid} ease;

  &:hover {
    border-color: ${({ $token }) => $token.colorPrimary};
  }
`;

export const CheckMark = styled.span<{ $token: GlobalToken }>`
  position: absolute;
  top: 10px;
  right: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: ${radius.circle};
  color: ${({ $token }) => $token.colorWhite};
  background: ${({ $token }) => $token.colorPrimary};
`;

export const CardName = styled.span<{ $token: GlobalToken }>`
  color: ${({ $token }) => $token.colorText};
  font-size: 15px;
  font-weight: ${({ $token }) => $token.fontWeightStrong};
`;

export const CardDescription = styled.span<{ $token: GlobalToken }>`
  color: ${({ $token }) => $token.colorTextTertiary};
  font-size: 13px;
  letter-spacing: -0.26px;
  line-height: 1.45;
`;
